import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'

const ACCOUNT_TYPES = ['Roth IRA', 'Traditional IRA', 'Brokerage', '401k', 'HSA', '529']

function InvestmentForm({ open, onSubmit, onClose }) {
  const [account, setAccount] = useState('')
  const [accountType, setAccountType] = useState(ACCOUNT_TYPES[0])
  const [purchaseDate, setPurchaseDate] = useState('')
  const [symbol, setSymbol] = useState('')
  const [quantity, setQuantity] = useState('')
  const [purchasePrice, setPurchasePrice] = useState('')
  const [accountError, setAccountError] = useState('')

  if (!open) return null

  function handleAccountChange(e) {
    const val = e.target.value
    setAccount(val)
    setAccountError(val.includes('-') ? 'Account name cannot contain hyphens' : '')
  }

  function handleSubmit(e) {
    e.preventDefault()
    if (accountError) return
    if (!account || !purchaseDate || !symbol || !quantity || !purchasePrice) return
    onSubmit({
      account,
      account_type: accountType,
      purchase_date: purchaseDate,
      symbol,
      quantity: parseFloat(quantity),
      purchase_price: parseFloat(purchasePrice),
    })
  }

  return (
    <Form onSubmit={handleSubmit} aria-label="Add investment">
      <Form.Group className="mb-3" controlId="investAccount">
        <Form.Label>Account</Form.Label>
        <Form.Control
          type="text"
          value={account}
          onChange={handleAccountChange}
          isInvalid={!!accountError}
          required
        />
        {accountError && (
          <Form.Control.Feedback type="invalid">{accountError}</Form.Control.Feedback>
        )}
      </Form.Group>

      <Form.Group className="mb-3" controlId="investAccountType">
        <Form.Label>Account Type</Form.Label>
        <Form.Select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
          {ACCOUNT_TYPES.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3" controlId="investPurchaseDate">
        <Form.Label>Purchase Date</Form.Label>
        <Form.Control
          type="date"
          value={purchaseDate}
          onChange={(e) => setPurchaseDate(e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="investSymbol">
        <Form.Label>Symbol</Form.Label>
        <Form.Control
          type="text"
          value={symbol}
          onChange={(e) => setSymbol(e.target.value)}
          onBlur={(e) => setSymbol(e.target.value.toUpperCase())}
          required
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="investQuantity">
        <Form.Label>Quantity</Form.Label>
        <Form.Control
          type="number"
          min="0"
          step="any"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="investPurchasePrice">
        <Form.Label>Purchase Price</Form.Label>
        <Form.Control
          type="number"
          min="0"
          step="any"
          value={purchasePrice}
          onChange={(e) => setPurchasePrice(e.target.value)}
          required
        />
      </Form.Group>

      <div className="d-flex gap-2">
        <Button type="submit" variant="primary">Add Investment</Button>
        <Button variant="outline-secondary" onClick={onClose}>Cancel</Button>
      </div>
    </Form>
  )
}

export default InvestmentForm
